import React from 'react';
import './WhyWorkWithUsSection.css';

function WhyWorkWithUsSection() {
  const reasons = [
    {
      title: 'Strategic Partnership',
      description: 'We prioritize long-term business relationships built on mutual success and operational reliability.'
    },
    {
      title: 'Supply Chain Excellence',
      description: 'Scalable wholesaling solutions that adapt to your growth while maintaining consistent quality and delivery.'
    },
    {
      title: 'Professional Operations',
      description: 'Clear communication, transparent processes, and professional execution across all wholesale activities.'
    },
    {
      title: 'Industry Expertise',
      description: 'Deep understanding of wholesale markets, supplier networks, and distribution channel requirements.'
    }
  ];

  return (
    <section id="partnerships" className="why-work-section">
      <div className="section-container">
        <div className="why-work-header">
          <h2>Why Partner With Northstar Bridge Commerce</h2>
        </div>

        <div className="reasons-grid">
          {reasons.map((reason, index) => (
            <div key={index} className="reason-card">
              <div className="reason-number">{index + 1}</div>
              <h3>{reason.title}</h3>
              <p>{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyWorkWithUsSection;
